import { TeamView } from '@trackly/shared';

// ~~ Factory ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

export function createDefaultTeam(createdBy: string = 'Unknown User'): TeamView {
  const currentDateTime = new Date().toISOString();

  return {
    id: '',
    name: '',
    description: '',
    status: 'ACTIVE',
    members: [],
    assignedCategories: [],
    createdDate: currentDateTime,
    createdBy: createdBy,
    lastModified: currentDateTime,
    modifiedBy: createdBy,
    memberCount: 0,
    activeMemberCount: 0,
    memberNames: [],
    isActive: true,
    categoryCount: 0,
    categoryValues: [],
  };
}
